import { getImportacionApiUrl } from 'src/app/core/config/importacion.config';
import {
	IMPORTACION_CONSULTAR,
	VERIFICACION_CONSULTAR
} from './importacion-permisos';

export interface MenuItem {
	id: number;
	routeMenu: string;
	active?: boolean;
	iconName: string;
	name: string;
	subMenu: SubMenu[];
	visible?: boolean;
}

export interface SubMenu {
	id: string | number;
	iconName: string;
	name: string;
	routeName: string;
	visible?: boolean;
	requiredPermission?: string;
	enabled?: boolean;
}

export const MENU_ITEMS: MenuItem[] = [
	{
		id: 9,
		routeMenu: 'importacion',
		iconName: 'globe',
		name: 'Importación',
		subMenu: [
			{
				id: 'ConsultarStockImportado',
				iconName: 'warehouse',
				name: 'Consulta de Stock Importado',
				routeName: 'stock',
				requiredPermission: IMPORTACION_CONSULTAR,
				enabled: !!getImportacionApiUrl()
			},
			{
				id: 'ConsultarProcesosIngresoImportacion',
				iconName: 'search-check',
				name: 'Procesos de Importación de Ingresos',
				routeName: 'procesos-ingreso',
				requiredPermission: IMPORTACION_CONSULTAR,
				enabled: !!getImportacionApiUrl()
			},
			{
				id: 'ConsultarProcesosTrasladoImportacion',
				iconName: 'search-check',
				name: 'Procesos de Importación de Movimientos de Traslado',
				routeName: 'procesos-traslado',
				requiredPermission: IMPORTACION_CONSULTAR,
				enabled: !!getImportacionApiUrl()
			},
			{
				id: 'ConsultarTrasladosImportados',
				iconName: 'search-check',
				name: 'Consulta de Traslados de Importación',
				routeName: 'traslados',
				requiredPermission: IMPORTACION_CONSULTAR,
				enabled: !!getImportacionApiUrl()
			},
			{
				id: 'VerificarEmbarquesConsolidados',
				iconName: 'clipboard-check',
				name: 'Verificar Embarques Consolidados',
				routeName: 'verificaciones-consolidados',
				requiredPermission: VERIFICACION_CONSULTAR,
				enabled: !!getImportacionApiUrl()
			},
			{
				id: 'ConsultarVerificacionesEmbarqueImportacion',
				iconName: 'clipboard-check',
				name: 'Verificar Embarques de Importación',
				routeName: 'verificaciones-embarque',
				requiredPermission: VERIFICACION_CONSULTAR,
				enabled: !!getImportacionApiUrl()
			},
			{
				id: 'ConsultarEmbarquesConsolidados',
				iconName: 'ship',
				name: 'Administrar Embarques Consolidados',
				routeName: 'embarques-consolidados',
				requiredPermission: IMPORTACION_CONSULTAR,
				enabled: !!getImportacionApiUrl()
			},
			{
				id: 'ConsultarProcesosEmbarqueImportacion',
				iconName: 'search-check',
				name: 'Procesos de Importación de Embarque',
				routeName: 'procesos-embarque',
				requiredPermission: IMPORTACION_CONSULTAR,
				enabled: !!getImportacionApiUrl()
			},
			{
				id: 'ConsultarProcesosMoliendaImportacion',
				iconName: 'search-check',
				name: 'Procesos de Importación de Molienda',
				routeName: 'procesos-molienda',
				requiredPermission: IMPORTACION_CONSULTAR,
				enabled: !!getImportacionApiUrl()
			},
			{
				id: 'ConsultarEmbarquesImportados',
				iconName: 'ship',
				name: 'Administrar Embarques de Importación',
				routeName: 'embarques',
				requiredPermission: IMPORTACION_CONSULTAR,
				enabled: !!getImportacionApiUrl()
			},
			{
				id: 'ConsultarMoliendasImportadas',
				iconName: 'search-check',
				name: 'Consulta de Molienda de Importación',
				routeName: 'moliendas',
				requiredPermission: IMPORTACION_CONSULTAR,
				enabled: !!getImportacionApiUrl()
			},
			{
				id: 'VerificacionIngresoImportado',
				iconName: 'clipboard-check',
				name: 'Administración de Importación',
				routeName: 'verificaciones-ingreso',
				requiredPermission: VERIFICACION_CONSULTAR,
				enabled: !!getImportacionApiUrl()
			}
		]
	},
	{
		id: 1,
		routeMenu: 'security',
		iconName: 'lock',
		name: 'Seguridad',
		subMenu: [
			{
				id: 'AdministradorUsuarios',
				iconName: 'user-lock',
				name: 'Administración Usuarios',
				requiredPermission: 'Seguridad.Usuario.Consultar',
				routeName: 'admin-user'
			},
			{
				id: 'AdministradorEmpresa',
				iconName: 'building',
				name: 'Administración Empresas',
				requiredPermission: 'Seguridad.Empresa.Consultar',
				routeName: 'admin-company'
			}
		]
	},
	{
		id: 8,
		routeMenu: 'company-profile',
		iconName: 'building',
		name: 'Perfil Empresa',
		subMenu: [
			{
				id: 'ConsultarSucursales',
				iconName: 'search-check',
				name: 'Consulta de Sucursales',
				requiredPermission: 'Sucursal.Sucursal.Consultar',
				routeName: 'branches-query'
			}
		]
	},
	{
		id: 2,
		routeMenu: 'establishment',
		iconName: 'map-pin',
		name: 'Unidades Productivas',
		subMenu: [
			{
				id: 'GestorUnidadProductivaConRestriccion',
				iconName: 'map-pin-check',
				name: 'Administración Unidades Productivas',
				requiredPermission: 'UnidadesProductivas.UnidadProductiva.Consultar',
				routeName: ''
			},
			{
				id: 'GestorUnidadProductivaConRestriccion',
				iconName: 'import',
				name: 'Proceso de Importación de Unidades Productivas',
				requiredPermission:
					'UnidadesProductivas.ImportacionUnidadProductiva.Consultar',
				routeName: 'import-processes-productive-units'
			},
			{
				id: 'VisualizadorProduccionUnidadesProductivas',
				iconName: 'search-check',
				name: 'Consulta de Producción',
				requiredPermission:
					'UnidadesProductivas.UnidadProductiva.ConsultarProducción',
				routeName: 'consultar-produccion-unidades'
			},
			{
				id: 'GestorUnidadProductivaConRestriccion',
				iconName: 'search-check',
				name: 'Consulta de Unidades Productivas Indirectas',
				requiredPermission: 'UnidadesProductivas.UnidadProductiva.Consultar',
				routeName: 'consultar-unidades-productivas-indirectas'
			}
		]
	},
	{
		id: 3,
		routeMenu: 'tracking',
		iconName: 'truck',
		name: 'Movimientos',
		subMenu: [
			{
				id: 'GestorCartaPorte',
				iconName: 'file-text',
				name: 'Administración Cartas de Porte',
				requiredPermission: 'Trazabilidad.CartaPorte.Consultar',
				routeName: 'admin-waybills'
			},
			{
				id: 'GestorCartaPorte',
				iconName: 'import',
				name: 'Proceso de Importación de Cartas de Porte',
				requiredPermission: 'Trazabilidad.ImportacionCartaPorte.Consultar',
				routeName: 'import-process-waybills'
			},
			{
				id: 'VisualizadorTraslado',
				iconName: 'search-check',
				name: 'Consulta de Movimientos de Traslado',
				requiredPermission: 'Trazabilidad.Traslado.Consultar',
				routeName: 'consult-tracking-moves'
			},
			{
				id: 'VisualizadorTraslado',
				iconName: 'import',
				name: 'Proceso de Importación Movimientos Traslado',
				requiredPermission: 'Trazabilidad.ImportacionTraslado.Consultar',
				routeName: 'import-tracking-moves'
			},
			{
				id: 'VisualizadorMolienda',
				iconName: 'search-check',
				name: 'Consulta de Molienda',
				requiredPermission: 'Trazabilidad.Molienda.Consultar',
				routeName: 'consult-milling'
			},
			{
				id: 'VisualizadorMolienda',
				iconName: 'import',
				name: 'Proceso de Importación Molienda',
				requiredPermission: 'Trazabilidad.ImportacionMolienda.Consultar',
				routeName: 'import-milling'
			}
		]
	},
	{
		id: 4,
		routeMenu: 'stock',
		iconName: 'warehouse',
		name: 'Stock',
		subMenu: [
			{
				id: 'GestorCartaPorte',
				iconName: 'search-check',
				name: 'Consulta de Stock',
				requiredPermission: 'Trazabilidad.CartaPorte.Consultar',
				routeName: 'consulta-stock'
			}
		]
	},
	{
		id: 5,
		routeMenu: 'shipment',
		iconName: 'ship',
		name: 'Embarques',
		subMenu: [
			{
				id: 'GestorEmbarque',
				iconName: 'search-check',
				name: 'Consulta de Embarque',
				requiredPermission: 'Exportacion.Embarque.Consultar',
				routeName: 'consult-shipment'
			},
			{
				id: 'VisualizadorEmbarque',
				iconName: 'import',
				name: 'Proceso de Importación de Embarque',
				requiredPermission: 'Trazabilidad.ImportacionEmbarque.Consultar',
				routeName: 'import-shipment'
			},
			{
				id: 'VisualizadorVerificacionEmbarque',
				iconName: 'ship',
				name: 'Verificación de Embarque',
				requiredPermission: 'Exportacion.Embarque.Verificacion.Consultar',
				routeName: 'verify-shipment'
			}
		]
	},
	{
		id: 6,
		routeMenu: 'traceability',
		iconName: 'route',
		name: 'Trazabilidad',
		subMenu: [
			{
				id: 'GestorCartaPorte',
				iconName: 'search-check',
				name: 'Consulta de Trazabilidad',
				requiredPermission: 'Trazabilidad.CartaPorte.ConsultarTrazabilidad',
				routeName: 'consultar-trazabilidad'
			}
		]
	},
	{
		id: 7,
		routeMenu: 'audit',
		iconName: 'file-check',
		name: 'Auditorías',
		subMenu: [
			{
				id: 'AuditorSucursales',
				iconName: 'book-check',
				name: 'Auditoría de Sucursales',
				requiredPermission: 'Auditoria.Auditoria.Consultar',
				routeName: 'audit-branches'
			}
		]
	}
];
